var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2277,
    height: 482,
    viewBox: "0 0 2277 482",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2220_476)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2220_476",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 2277,
    height: 482
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2277 0H0V482H2277V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2220_476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2277 0H0V482H2277V0Z",
    fill: "url(#paint0_linear_2220_476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7954 401.686L139.047 80.3438H272.643C317.062 80.3438 349.126 86.7485 368.693 99.6149C388.346 112.452 398.23 133.112 398.23 161.622C398.23 179.958 394.622 195.374 387.495 208.099C380.394 220.766 369.262 231.195 354.294 239.442C367.159 244.996 377.015 253.385 384.114 264.637C391.044 276.029 394.622 288.98 394.622 303.745C394.622 336.222 383.859 360.764 362.388 377.116C340.86 393.609 308.854 401.743 266.197 401.743H90.7954V401.686ZM200.932 327.21H251.314C267.758 327.21 279.743 324.575 287.155 319.331C294.568 314.174 298.288 305.558 298.288 293.939C298.288 283.964 294.995 276.851 288.405 272.515C281.76 268.179 270.286 266.025 253.984 266.025H209.878L200.903 327.21H200.932ZM217.66 208.92H259.863C275.37 208.92 286.559 206.597 293.432 201.609C300.163 196.791 303.713 188.799 303.713 177.775C303.713 168.564 300.589 162.047 294.397 158.278C288.206 154.593 275.966 152.751 257.676 152.751H227.061L217.631 208.92H217.66Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.869 401.686L455.059 80.3145H703.96L692.116 156.775H543.782L536.568 200.928H668.601L657.099 272.4H525.406L518.562 323.922H676.638L665.619 401.686H405.841H405.869Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.603 401.686L808.075 162.017H716.626L730.201 80.3145H1011.45L997.421 162.017H910.146L875.242 401.686H772.603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.408 401.686L1038.11 80.3145H1264.56L1252.09 159.042H1126.87L1118.72 209.826H1225.16L1213.15 286.343H1107.42L1090.54 401.686H989.38H989.408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.47 401.686L1293.41 80.3145H1442.51C1484.12 80.3145 1514.48 87.2293 1533.68 101.116C1552.93 115.031 1562.56 136.796 1562.56 166.665C1562.56 188.061 1557.36 206.567 1546.94 221.87C1536.51 237.288 1521.29 249.275 1501.19 257.918C1515.47 263.36 1525.61 270.586 1531.71 279.145C1537.8 287.789 1540.8 299.238 1540.8 313.663C1540.8 316.752 1540.74 319.955 1540.55 323.44C1540.32 326.897 1540.01 330.439 1539.58 334.18L1536.06 366.799C1535.66 369.804 1535.38 372.043 1535.26 373.346C1535.26 374.763 1535.18 376.124 1535.18 377.455C1535.18 381.593 1535.97 385.022 1537.66 387.544C1539.19 390.038 1541.75 391.994 1545.15 393.382V401.657H1436.44C1435.86 399.617 1435.49 397.35 1435.24 394.997C1435.07 392.588 1434.9 390.038 1434.9 387.204C1434.9 385.39 1435.07 382.981 1435.24 380.034C1435.46 377.143 1435.8 373.629 1436.21 369.577L1440.78 337.213C1441.07 335.314 1441.27 333.331 1441.41 331.375C1441.55 329.306 1441.61 326.585 1441.61 323.128C1441.61 309.412 1437.74 299.777 1429.9 294.25C1422.12 288.724 1408.43 285.974 1388.78 285.974H1362.39L1344.75 401.657H1245.47V401.686ZM1372.1 217.535H1421.21C1436.66 217.535 1447.96 214.956 1455.27 209.543C1462.62 204.215 1466.26 195.855 1466.26 184.519C1466.26 174.742 1463.07 167.6 1456.66 163.322C1450.2 158.872 1439.73 156.775 1425.16 156.775H1381.62L1372.1 217.535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1570.91 401.686L1620.13 80.3145H1869.06L1857.21 156.775H1708.82L1701.64 200.928H1833.69L1822.14 272.4H1690.48L1683.71 323.922H1841.65L1830.63 401.686H1570.88H1570.91Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1860.85 401.686L1908.67 80.3145H2036.73C2069.08 80.3145 2094.07 83.9418 2111.87 91.1684C2129.66 98.4803 2145.22 110.808 2158.51 128.265C2167.4 139.941 2174.21 153.997 2179.08 170.519C2183.81 186.957 2186.23 204.924 2186.23 224.251C2186.23 281.696 2171.04 325.651 2140.77 356.088C2110.46 386.438 2066.69 401.657 2009.38 401.657H1860.85V401.686ZM1974.45 321.91H1998.19C2014.38 321.91 2026.74 320.662 2034.94 318.168C2043.38 315.76 2050.79 311.509 2057.24 305.53C2064.88 298.387 2071.3 287.165 2076.15 272.315C2081.18 257.494 2083.63 241.596 2083.63 224.705C2083.63 200.531 2078.97 183.443 2069.57 173.58C2060.31 163.689 2044.23 158.815 2021.31 158.815H1998.19L1974.45 321.938V321.91Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2220_476",
    x1: 0,
    y1: 241,
    x2: 2277,
    y2: 241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E21937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#82368C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004990"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2220_476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2277,
    height: 482,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBf);
export default __webpack_public_path__ + "static/media/bf.928d3cf2ab77f681e616aa430f8cb7f8.svg";
export { ForwardRef as ReactComponent };